import {daysBetween} from 'shared/utils/dateTime';

export function perDay(budget: Budget): MoneyAmount {
  const {initial, added, finishDate, startDate} = budget;
  if (finishDate === startDate) return 0;

  return Math.floor((initial + added) / daysBetween(finishDate, startDate));
}
